import Ajax from './ajax';

const pricingFetchUrl = window.location.origin + '/api/v1/products/';

export default function(productId, callback) {
    if(productId) {
        var pricing = false,
            callback = callback || function () {
                };
        Ajax('GET',
            pricingFetchUrl + encodeURIComponent(productId) + '/pricing/',
            {},
            function (response) {
                var responseJson = JSON.parse(response);
                if (!!responseJson && responseJson.length )
                    pricing = responseJson;
                callback(pricing);
            }
        );
    }
};
